export default {"src":"/_next/static/media/cloud-compute.c30d98e2.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};